import { createSelector } from 'reselect';
import { statsLeadersSelector } from './simple-selectors';

export const statsLeadersDataTypeSelector = createSelector(
    statsLeadersSelector,
    (statsLeaders) => statsLeaders.dataType
);
